import { entryPoints, eventActions, eventContents, eventLabels } from './constants'
import { sendInteractionGtm, sendPageviewGtm, setEntryPoint, toCd1 } from './helpers'

// Показ страницы списка игр
export const gamesListPageShowGtm = () =>
  sendPageviewGtm({
    eventLabel: eventLabels.categoryStranica,
    eventContent: eventContents.igry,
  })

// Показ страницы списка сервисов
export const servicesListPageShowGtm = () =>
  sendPageviewGtm({
    eventLabel: eventLabels.categoryStranica,
    eventContent: eventContents.servisy,
  })

// Показ страницы списка ключей
export const keysListPageShowGtm = () =>
  sendPageviewGtm({
    eventLabel: eventLabels.categoryStranica,
    eventContent: eventContents.igrovyeKluchi,
  })

// Показ страницы списка новостей
export const newsListPageShowGtm = () =>
  sendPageviewGtm({
    eventLabel: eventLabels.categoryStranica,
    eventContent: eventContents.novosti,
  })

const categoryServiceClickGtm = (eventLabel: string, productName: string) => {
  setEntryPoint(entryPoints.categoryStranica)

  sendInteractionGtm({
    eventAction: eventActions.cardClick,
    eventLabel,
    CD1: { serviceName: toCd1(productName) },
  })
}

// Клик на сервис на странице списка игр
export const gamesListClickGtm = (productName: string) => categoryServiceClickGtm(eventLabels.igry, productName)

// Клик на сервис на странице списка ключей
export const keysListClickGtm = (productName: string) =>
  categoryServiceClickGtm(eventLabels.igrovyeKlyuchi, productName)

// Клик на сервис на странице списка сервисов
export const servicesListClickGtm = (productName: string) => categoryServiceClickGtm(eventLabels.servicy, productName)

// Клик на рекламный баннер на странице списка новостей
export const newsBannerClickGtm = (bannerName: string) => {
  setEntryPoint(entryPoints.reklamnyiBanner)

  sendInteractionGtm({
    eventAction: eventActions.elementClick,
    eventLabel: eventLabels.reklamnyiBanner,
    eventContent: eventContents.novosti,
    bannerName: toCd1(bannerName),
  })
}
